import { nanoid } from "@reduxjs/toolkit"
import classNames from "classnames"
import Avatar from "common/components/Avatar"
import { rangeArrayFromNumber } from "features/User/utils"
import { useTranslation } from "react-i18next"

const UsersSteps = ({ etapa, flexContainer }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <div
      className={classNames("card-approval__item-container", {
        flex: flexContainer,
      })}
    >
      <Avatar
        initials={etapa.departamentoNombre.slice(0, 2).toUpperCase() ?? ""}
      />
      <div
        key={Math.random()}
        className='item'
      >
        <h5>{etapa.departamentoNombre}</h5>
        <ul className='card-approval__users-container'>
          {rangeArrayFromNumber(2, etapa.numeroFirmas, 1)
            .fill(etapa.numeroFirmas)
            .map(() => {
              return (
                <li
                  key={nanoid()}
                  className='card-approval__step'
                >
                  <span />
                  <p>{t("flujoAprobaciones.types.employeeLabel")}</p>
                </li>
              )
            })}
          <li
            key={nanoid()}
            className='card-approval__step'
          >
            <span />
            <p>{t("flujoAprobaciones.types.responsibleLabel")}</p>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default UsersSteps
